import script from "./ButtonPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonPopup.vue?vue&type=style&index=0&id=69263dde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69263dde"]])

export default __exports__